var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pCloud_svg__clip0_562_45694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.117a3.21 3.21 0 00-1.202-2.504 2.74 2.74 0 01-1.384 1.302 2.668 2.668 0 00-1.225-5.049 1.623 1.623 0 00-.32.02c.386.828.584 1.731.582 2.645v.18a6.423 6.423 0 00-12.839-.02v-.16a6.623 6.623 0 01.581-2.665 4.745 4.745 0 00.561 9.457h12.117A3.188 3.188 0 0020 10.117z",
    fill: "#1BBED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99 1.723a5.17 5.17 0 105.195 5.17 5.184 5.184 0 00-5.195-5.17zm0 9.676a4.509 4.509 0 114.513-4.507A4.517 4.517 0 019.99 11.4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.605 4.205a.761.761 0 00-.761.761v4.13a.761.761 0 001.522 0v-.881h1.483a2.004 2.004 0 000-4.01m-.02 2.586H9.366V5.608h1.483a.604.604 0 01.601.6.617.617 0 01-.622.582",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pCloud_svg__clip0_562_45694"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h20v12.823H0z"
  })))));
}
export default SvgPCloud;